/* ----------------------------------------
    Module
---------------------------------------- */

import { extend } from 'lodash';

/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            aliasList: {},
            classPrefix: 'vv-'
        };
    },
    computed: {
        classname() {
            const staticClass = this.$vnode.data.staticClass;
            const componentName = this.$options.name.toLowerCase();
            return staticClass ? staticClass : componentName;
        },
        alias() {
            return this.aliasList;
        },
    },
    methods: {
        addAlias(alias) {
            const component = this.classname;

            _.extend(this.aliasList, {
                get [alias]() {
                    return `${ component }__${ alias }`
                }
            });
        }
    },
    mounted() {
        const componentName = this.classPrefix + this.$options.name.toLowerCase();
        this.$vnode.elm.classList.add(componentName);

        const component = this.classname;

        this.aliasList = {};

        if(this.aliasNames) {
            this.aliasNames.map(name => {
                _.extend(this.aliasList, {
                    get [name]() {
                        const className = `${ component }__${ name }`;
                        const defaultClassName = `${ componentName }__${ name }`;

                        if(className === defaultClassName)
                            return className;

                        return `${ className } ${ defaultClassName }`
                    }
                });
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export class componentMixin extends Vue {}